'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_model$package$ImageId$() {
  this.a9M = 0;
  this.a9N = 0;
  $n_Lmealorama_model$package$ImageId$ = this;
  $m_Lmealorama_model$package$ImageId$();
  this.a9M = 0;
  this.a9N = 0;
}
export { $c_Lmealorama_model$package$ImageId$ as $c_Lmealorama_model$package$ImageId$ };
$p = $c_Lmealorama_model$package$ImageId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_model$package$ImageId$;
/** @constructor */
function $h_Lmealorama_model$package$ImageId$() {
}
export { $h_Lmealorama_model$package$ImageId$ as $h_Lmealorama_model$package$ImageId$ };
$h_Lmealorama_model$package$ImageId$.prototype = $p;
var $d_Lmealorama_model$package$ImageId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_model$package$ImageId$, "mealorama.model$package$ImageId$", ({
  KP: 1
}));
export { $d_Lmealorama_model$package$ImageId$ as $d_Lmealorama_model$package$ImageId$ };
var $n_Lmealorama_model$package$ImageId$;
function $m_Lmealorama_model$package$ImageId$() {
  if ((!$n_Lmealorama_model$package$ImageId$)) {
    $n_Lmealorama_model$package$ImageId$ = new $c_Lmealorama_model$package$ImageId$();
  }
  return $n_Lmealorama_model$package$ImageId$;
}
export { $m_Lmealorama_model$package$ImageId$ as $m_Lmealorama_model$package$ImageId$ };
//# sourceMappingURL=mealorama.model$package$-Image-Id$.js.map
